import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Box, Text, Flex } from '@chakra-ui/react'
import { CardRow, CardRowMain } from './CardRow'
import { isEmpty, getDayOfWeek, capitalizeFirstLetter } from 'src/utils/helpers'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import intlMessagesApp from 'src/modules/App/translations'
import styles from './ContactDetails.module.less'

class ContactDetails extends Component {
  state = {
    isCollapsed: false,
    isCollapsedWorkingHours: true,
  }

  toggleWorkingHours = () => {
    this.setState({
      isCollapsedWorkingHours: !this.state.isCollapsedWorkingHours,
    })
  }

  renderWorkHours = day => {
    const { intl, data } = this.props

    const hours =
      data.hasOwnProperty('workingHours') &&
      data.workingHours.hasOwnProperty(day) &&
      data.workingHours[day]
        ? data.workingHours[day]
        : null

    const from = hours && hours.hasOwnProperty('from') && hours.from ? hours.from : null
    const to = hours && hours.hasOwnProperty('to') && hours.to ? hours.to : null

    return (
      <Box className={styles.dayValue}>
        {hours ? (
          <Text variant='card' ml={'10px'} className={styles.hours} fontSize={'14px'}>
            <span className={styles.hour}>{from}</span>
            <span className={styles.hoursSeparator}>-</span>
            <span className={styles.hour}>{to}</span>
          </Text>
        ) : (
          <Text variant='card' ml={'10px'} fontSize={'14px'}>
            {intl.formatMessage(intlMessagesApp.appGlobalClosed)}
          </Text>
        )}
      </Box>
    )
  }

  handleCall = phone => window.open(`tel:${phone}`, '_self')
  handleEmail = email => window.open(`mailto:${email}`)

  render() {
    const { intl, className, timeZone, data } = this.props

    const { isCollapsedWorkingHours } = this.state

    if (isEmpty(data)) {
      return ''
    }
    // Get mon-sun for current day
    const dayOfWeek = getDayOfWeek(timeZone)

    const cxCard = cx({
      [styles.card]: true,
      [className]: !!className,
    })

    const cxPrimaryColor = cx({
      'kiosk-color--primary-color': true,
      'kiosk-color--primary-color-hover': true,
    })

    const cxWorkingHoursToggle = cx({
      [styles.collapseTriggerIcon]: true,
      [styles.collapseTriggerIconExpanded]: isCollapsedWorkingHours === false,
    })

    const cxWorkingHoursSummary = cx({
      [styles.hoursSummary]: true,
      [styles.hiddenRowContent]: !isCollapsedWorkingHours,
      [styles.visibleRowContent]: isCollapsedWorkingHours,
    })

    const cxWorkingHoursFull = cx({
      [styles.hiddenRowContent]: isCollapsedWorkingHours,
      [styles.visibleRowContent]: !isCollapsedWorkingHours,
    })

    return (
      <Box className={cxCard}>
        <Flex align={'center'} p={'16px'} minHeight={'84px'}>
          {data.hasOwnProperty('image') && data.image ? (
            <Box mr={'18px'} className={styles.imageHolder}>
              <img src={data.image} alt='Logo' className={styles.image} />
            </Box>
          ) : (
            ''
          )}

          <Box ml={data.image ? '16px' : ''} className={styles.header}>
            {data.hasOwnProperty('name') && data.name ? (
              <Text variant='card' fontSize={'18px'} fontWeight={'bold'}>
                {data.name}
              </Text>
            ) : (
              ''
            )}
            {data.hasOwnProperty('address') && data.address ? (
              <Text variant='card' opacity={0.8} fontSize={'14px'}>
                {data.address}
              </Text>
            ) : (
              ''
            )}
          </Box>
        </Flex>

        {data.address && (
          <Box
            cursor={'pointer'}
            onClick={() =>
              window.open(`https://maps.google.com/?q=${data.address},${data.name}`, '_blank')
            }
          >
            <CardRow>
              <Box opacity={0.5}>
                <FontAwesomeIconComponent
                  icon={['far', 'location-dot']}
                  size='xs'
                  type='card-font'
                />
              </Box>
              <Text ml={'10px'} variant='card'>
                {data.address}
              </Text>
            </CardRow>
          </Box>
        )}

        {data.hasOwnProperty('workingHours') &&
        Array.isArray(Object.keys(data.workingHours)) &&
        !isEmpty(data.workingHours) ? (
          <CardRow className={styles.rowWorkingHours}>
            <Box opacity={0.5}>
              <FontAwesomeIconComponent icon={['far', 'clock']} size='xs' type='card-font' />
            </Box>
            <CardRowMain>
              <div className={cxWorkingHoursSummary}>
                <div className={styles.hoursSummaryInner}>{this.renderWorkHours(dayOfWeek)}</div>
              </div>
              <Box ml={'10px'} className={cxWorkingHoursFull}>
                {Object.keys(data.workingHours).map((day, dayKey) => {
                  return (
                    <div key={'work-day-' + dayKey} className={styles.workDay}>
                      <Text fontSize={'14px'} className={styles.dayLabel} variant='card'>
                        {intl.formatMessage(
                          intlMessagesApp['appGlobalWeekDays' + capitalizeFirstLetter(day)],
                        )}
                      </Text>
                      {this.renderWorkHours(day)}
                    </div>
                  )
                })}
              </Box>
            </CardRowMain>
            {dayOfWeek && (
              <div className={styles.rowCollapseTrigger} onClick={this.toggleWorkingHours}>
                <FontAwesomeIconComponent
                  type='card-font'
                  icon={['far', 'chevron-down']}
                  size='xs'
                  className={cxPrimaryColor + ' ' + cxWorkingHoursToggle}
                />
              </div>
            )}
          </CardRow>
        ) : (
          ''
        )}

        {data.hasOwnProperty('phones') && Array.isArray(data.phones) && !isEmpty(data.phones)
          ? data.phones.map((phone, phoneKey) => {
              const type = phone.hasOwnProperty('type') && phone.type ? phone.type : null
              const value = phone.hasOwnProperty('value') && phone.value ? phone.value : null

              if (!value) {
                return ''
              }

              let label = intl.formatMessage(intlMessagesApp.appGlobalPhonesPhone)
              if (type && type === 'claimsPhone') {
                label = intl.formatMessage(intlMessagesApp.appGlobalPhonesClaimsPhone)
              }
              if (type && type === 'emergencyClaimsPhone') {
                label = intl.formatMessage(intlMessagesApp.appGlobalPhonesEmergencyPhone)
              }

              return (
                <CardRow key={'phone-' + phoneKey} className={styles.rowPhones}>
                  <Flex onClick={() => this.handleCall(value)}>
                    <Box opacity={0.5}>
                      <FontAwesomeIconComponent
                        icon={['far', 'phone']}
                        size='xs'
                        type='card-font'
                      />
                    </Box>
                    <Flex ml={'10px'} direction={'column'}>
                      <div>
                        <div className={styles.phoneDetails}>
                          <Text fontSize={'14px'} variant='card'>
                            {value}
                          </Text>
                          {type && (
                            <Text
                              opacity={0.7}
                              fontSize={'13px'}
                              lineHeight={'13px'}
                              variant='card'
                            >
                              {label}
                            </Text>
                          )}
                        </div>
                      </div>
                    </Flex>
                  </Flex>
                </CardRow>
              )
            })
          : ''}
      </Box>
    )
  }
}

ContactDetails.propTypes = {
  intl: PropTypes.object,
  className: PropTypes.string,
  data: PropTypes.object,
  timeZone: PropTypes.number,
  isCollapsible: PropTypes.bool,
}

ContactDetails.defaultProps = {
  isCollapsible: false,
}

export default injectIntl(ContactDetails)
